module.exports = __webpack_public_path__ + "static/assets/455062dce6061a4c60d714390d93838d.png";